import { OfficeTab, OfficeType } from '../types/seatTypes';

/**
 * 사무실별 도면 이미지 경로
 */
export const OFFICE_IMAGE_PATHS: Record<OfficeType, string> = {
  main: 'src/assets/organizationLayoutImage/fullLayout.svg',
} as const;

/**
 * 사무실 탭 목록
 */
export const OFFICE_TABS: readonly OfficeTab[] = [{ label: '본사', value: 'main', officeSid: 1 }];

/**
 * 사무실 타입으로 이름 찾기
 */
export const getOfficeNameByType = (officeType: OfficeType): string => {
  const tab = OFFICE_TABS.find((t) => t.value === officeType);
  return tab?.label || '본사';
};
